var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_leaveCancelReason_from_newTitle"),
      widthClass: "max-1000",
      initData: _vm.leaveCancelData,
      backgroundClass: "white",
      checkData: [
        "leave_reason_name",
        "leave_reason_code",
        "leave_reason_description",
        "sequence",
        "remarks",
      ],
    },
    on: {
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c(
              "v-container",
              { staticClass: "pa-0", attrs: { fluid: "" } },
              [
                _c(
                  "v-form",
                  { ref: "form", attrs: { "lazy-validation": "" } },
                  [
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "12",
                              md: "12",
                              lg: "12",
                              cols: "12",
                            },
                          },
                          [
                            _c("inputTextFiledMultiLang", {
                              attrs: {
                                bindData: _vm.leaveCancelData.leave_reason_name,
                                maxlength: "100",
                                label: _vm.$t(
                                  "label_essweb_leaveCancelReason_from_leaveCancelReasonNameLabel"
                                ),
                                rules: _vm.$GetRules(
                                  ["_Require_Rules"],
                                  [null]
                                ),
                              },
                              on: {
                                change: function (valueArr) {
                                  _vm.leaveCancelData.leave_reason_name =
                                    valueArr
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "6",
                              md: "6",
                              lg: "6",
                              cols: "12",
                            },
                          },
                          [
                            _c("normalInputTextFiled", {
                              attrs: {
                                type: "number",
                                label: _vm.$t(
                                  "label_essweb_leaveCancelReason_from_sequenceLabel"
                                ),
                                isNotRequire: "",
                                maxlength: "10",
                                rules: _vm.$GetRules(
                                  ["_Number_negative", "_Length_Rules"],
                                  [null, 10]
                                ),
                              },
                              model: {
                                value: _vm.leaveCancelData.sequence,
                                callback: function ($$v) {
                                  _vm.$set(_vm.leaveCancelData, "sequence", $$v)
                                },
                                expression: "leaveCancelData.sequence",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "6",
                              md: "6",
                              lg: "6",
                              cols: "12",
                            },
                          },
                          [
                            _c("normalInputTextFiled", {
                              attrs: {
                                label: _vm.$t(
                                  "label_essweb_leaveCancelReason_from_codeLabel"
                                ),
                                maxlength: "50",
                                rules: _vm.$GetRules(
                                  ["_Require_Rules"],
                                  [null]
                                ),
                              },
                              model: {
                                value: _vm.leaveCancelData.leave_reason_code,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.leaveCancelData,
                                    "leave_reason_code",
                                    $$v
                                  )
                                },
                                expression: "leaveCancelData.leave_reason_code",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "12",
                              md: "12",
                              lg: "12",
                              cols: "12",
                            },
                          },
                          [
                            _c("inputTextFiledMultiLang", {
                              attrs: {
                                bindData:
                                  _vm.leaveCancelData.leave_reason_description,
                                maxlength: "500",
                                label: _vm.$t(
                                  "label_essweb_leaveCancelReason_from_descriptionLabel"
                                ),
                              },
                              on: {
                                change: function (valueArr) {
                                  _vm.leaveCancelData.leave_reason_description =
                                    valueArr
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "12",
                              md: "12",
                              lg: "12",
                              cols: "12",
                            },
                          },
                          [
                            _c("v-sheet", { staticClass: "text--secondary" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_leaveCancelReason_from_remarkLabel"
                                  )
                                )
                              ),
                            ]),
                            _c("v-textarea", {
                              attrs: {
                                rows: "5",
                                "no-resize": "",
                                maxlength: "500",
                                filled: "",
                                dense: "",
                                counter: "500",
                                "single-line": "",
                                name: "input-7-4",
                              },
                              model: {
                                value: _vm.leaveCancelData.remarks,
                                callback: function ($$v) {
                                  _vm.$set(_vm.leaveCancelData, "remarks", $$v)
                                },
                                expression: "leaveCancelData.remarks",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { newBtn: "" },
              on: {
                new: _vm.toNew,
                cancel: function ($event) {
                  return _vm.$toBack(_vm.isChanged)
                },
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return undefined
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }